import   Vue                            from 'vue';
import   Vuebar                         from 'vuebar';
import   App                            from './App.vue';
import   store                          from './plugins/vuex';
import   vuetify                        from './plugins/vuetify';
import { EventBus,
         BotInjectorService,
         BotInitializationService }     from './';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'development') {
  window.botSettings = {}
  window.botSettings.faqId = process.env.VUE_APP_TEST_FAQ_ID;
  window.botSettings.botKey = process.env.VUE_APP_TEST_BOT_KEY;
  window.botSettings.synapseBotId = process.env.VUE_APP_TEST_BOT_NAME;
  window.botSettings.synapseWidgetRoot = process.env.VUE_APP_BASE_URL + ':' + process.env.VUE_APP_PORT + '/' + process.env.VUE_APP_CONTEXT;

  if (process.env.VUE_APP_EMBEDDED_MODE_ACTIVATED === 'true') {
    window.botSettings.showExtIntegration = true;
    window.botSettings.showCloseButton = true;
    window.botSettings.htmlElemIdForIntegration = process.env.VUE_APP_EMBEDDED_MODE_HTML_ELEM_ID;
    window.botSettings.htmlElemToHideInFullScreen = process.env.VUE_APP_EMBEDDED_MODE_FULLSCREEN_HTML_ELEM_ID;
  }
}

// Inject widget app
const tagId: string | undefined = BotInjectorService.getInjectionTagId();
if (!tagId || !document.getElementById(tagId)) {
  alert('Synapse Chatbot Agent:\nMissing required integration host HTML element. Please verify your configuration.');
} else {
  new Vue({ store,
            vuetify, 
            render: h => h(App) }).$mount('#' + tagId);
}

// Add custom scrollbar 
Vue.use(Vuebar);

window.onMessageBoxImageSelected = (allImgElements: NodeListOf<HTMLImageElement>, imgElementIndex: any) => {
  EventBus.$emit('ON_IMAGE_SELECTED', allImgElements, imgElementIndex);
};

window.onMessageBoxTableSelected = (allTablesElements: NodeListOf<HTMLTableElement>,  tableElementIndex:any) => {
  EventBus.$emit('ON_TABLE_SELECTED', allTablesElements, tableElementIndex);
};

// Assign handler to message event
if (window.addEventListener) {
  window.addEventListener('message', BotInitializationService.handleAdminAppMessage, false);
} else if ( window.attachEvent ) { // ie8
  window.attachEvent('onmessage', BotInitializationService.handleAdminAppMessage);
}
